import { useOutletContext } from 'react-router-dom';

import LessonProgressDashboardStats from '@/models/LessonProgressDashboardStats';
import { LessonItem } from '@/utils/lesson/lessonItems';

export type LessonOutletContext = {
  lessonId: number;
  tabs: LessonItem[];
  lessonProgress?: LessonProgressDashboardStats;
};

export const useLessonOutletContext = () =>
  useOutletContext<LessonOutletContext>();
